// extracted by mini-css-extract-plugin
module.exports = {"svgLarge":"TooltipWithIcon_svgLarge__17VHn","wrapper":"TooltipWithIcon_wrapper__2vqbk"};